<template>
  <div>
    <div v-if="!canRetryVerification">
      <div v-if="application.productType === 'DEALER'" class="small">
        {{ $t('LoanApplicationTimeline.verificationFailedForDealer') }}
      </div>
      <div v-else class="small">
        {{ $t('LoanApplicationTimeline.verificationFailed') }}
      </div>
    </div>
    <div v-else>
      <p class="small">{{ $t('LoanApplicationTimeline.verificationTitle') }}</p>
      <div class="alert alert-warning small rounded border mb-0 text-center px-0 py-2">
        <button class="btn btn-sm btn-primary mt-3 mb-2 px-3" @click="startGetID()">{{$t('LoanApplicationTimeline.verificationStart')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@shared/store'

export default {
  name: 'IdentityVerificationFailedComponent',
  props: ['application'],
  data() {
    return {
      state: store.state,
      canRetryVerification: false
    }
  },
  created() {
    this.loadVerificationStatus()
  },
  methods: {
    startGetID() {
      this.$emit('on-verification-start')
    },
    loadVerificationStatus() {
      return this.$http.get(`/api/customers/${this.state.currentUser.pin}/verification/can-retry`).then(response => {
        this.canRetryVerification = response.data.canRetryVerification
      })
    }
  }
}
</script>
